import { StepPage } from "../../components/StepPage";
import { COBStep, getNextStepButtonText, getStepName } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
import VideoPlayer from "../../../components/VideoPlayer/VideoPlayer";
import { videoUrl } from "../../../models/intro-video";
import { Button } from 'seagull';
import styles from "./introVideoStepContainer.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const IntroVideoStep = _ref => {
  let {
    onDone,
    onBack
  } = _ref;
  const {
    relationship
  } = useCobConfig();
  const {
    introVideo
  } = relationship;
  const testId = 'intro-video-step';
  const url = introVideo && videoUrl(introVideo);
  if (!url) {
    throw new Error('Intro Video does not have URL');
  }
  return /*#__PURE__*/_jsx(StepPage, {
    header: getStepName(COBStep.introVideo),
    testid: testId,
    primaryBtn: /*#__PURE__*/_jsx(Button, {
      "data-testid": "".concat(testId, "-next-btn"),
      onClick: onDone,
      children: getNextStepButtonText(COBStep.introVideo, relationship)
    }),
    backBtnTestid: "".concat(testId, "-back-btn"),
    onBackBtnClick: onBack,
    contentClassName: styles.introVideoStepContainer,
    children: /*#__PURE__*/_jsx("div", {
      "data-testid": "".concat(testId, "-video"),
      children: /*#__PURE__*/_jsx(VideoPlayer, {
        url: url,
        height: '100%'
      })
    })
  });
};
export default IntroVideoStep;